import { writable } from 'svelte/store';

let state = {
    mobile: '',
    mobileID: '',
    receiverID: '',
};

let user = () => {
    const { subscribe, set, update } = writable(
        JSON.parse(localStorage.getItem('session')) || state
    );

    subscribe((value) => {
        localStorage.setItem('session', JSON.stringify(value));
    });

    return {
        subscribe,
        setMobile: (mobile) => {
            return update((store) => ({
                ...store,
                mobile: mobile,
            }));
        },
        setMobileID: (mobileID) => {
            return update((store) => ({
                ...store,
                mobileID: mobileID,
            }));
        },
        setReceiverID: (receiverID) => {
            return update((store) => ({
                ...store,
                receiverID: receiverID,
            }));
        },
        logout: () => {
            return update((store) => ({
                state,
            }));
        },
    };
};

export default user();
